import { render, staticRenderFns } from "./DneyeModule.vue?vue&type=template&id=547ee4a2&"
import script from "./DneyeModule.vue?vue&type=script&lang=ts&"
export * from "./DneyeModule.vue?vue&type=script&lang=ts&"
import style0 from "./DneyeModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports